import { render, staticRenderFns } from "./SwitchProjectCustomer.vue?vue&type=template&id=7f8b9d59"
import script from "./SwitchProjectCustomer.vue?vue&type=script&lang=js"
export * from "./SwitchProjectCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports